var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blok)?_c('storyblok',{staticClass:"headline",attrs:{"blok":_vm.blok}},[(_vm.tag)?_c(_vm.tag,{tag:"component"},[_vm._v(_vm._s(_vm.blok.headline)+" ")]):_c('h1',[_vm._v(_vm._s(_vm.blok.headline))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }